import { makeStyles } from 'tss-react/mui';

const useStylesImage: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  image: {
    width: 42,
    height: 'auto',
    maxHeight: 42,
  },
  imageSquare: {
    borderRadius: 0,
  },
  imageCentered: {
    margin: 'auto 0',
  },
  imageSmall: {
    width: 24,
    maxHeight: 24,
  },
}));

export default useStylesImage;
